import { CancellationToken } from '@cian/http-api/shared';

import { EMessageFileTypes } from './messageFiles';
import { IWsFileMessage } from '../actions/wsMessage/types';

export enum EUploadFilesStatus {
  Pending = 'pending',
  Succeed = 'succeed',
  Failed = 'failed',
  WsSucceed = 'wsSucceed',
}

export type TMessageFiles = {
  blobFiles?: TPendingBlobFile[];
  uploadedFiles?: IWsFileMessage[];
  status: EUploadFilesStatus;
};

export type TPendingBlobFile = {
  file: File;
  cancellationToken: CancellationToken;
  type: EMessageFileTypes;
};
